export const SITE_URL = "https://arifpay.net";
export const SITE_NAME = "Arifpay";
export const DEFAULT_OG_IMAGE = `${SITE_URL}/arifpaylogo.svg`;

export const DEFAULT_KEYWORDS =
  "Fintechs in Ethiopia, Best API integration in Ethiopia, Arifpay, Ethiopian fintech, payment gateway Ethiopia, payment API Ethiopia, Telebirr integration, POS Ethiopia";

export const organizationJsonLd = {
  "@context": "https://schema.org",
  "@type": "FinancialService",
  name: "Arifpay Financial Technologies Share Company",
  alternateName: "Arifpay",
  url: SITE_URL,
  logo: DEFAULT_OG_IMAGE,
  image: DEFAULT_OG_IMAGE,
  description:
    "Arifpay is a leading Ethiopian fintech platform offering secure digital payment gateways, mobile point-of-sale (mPOS), and financial technology solutions in Ethiopia.",
  telephone: "9395",
  email: "info@arifpay.net",
  address: {
    "@type": "PostalAddress",
    streetAddress: "Warka Tower, 3rd Floor, Bole Sub City, Namibia Street",
    addressLocality: "Addis Ababa",
    addressCountry: "ET",
  },
  areaServed: {
    "@type": "Country",
    name: "Ethiopia",
  },
  sameAs: [
    "https://www.facebook.com/ArifpayET",
    "https://twitter.com/ArifpayEthiopia",
    "https://et.linkedin.com/company/arifpay-financial-technologies-s-c",
    "https://www.instagram.com/arifpayet/",
  ],
};

export const homeFaqs = [
  {
    question: "Is Arifpay one of the top fintechs in Ethiopia?",
    answer:
      "Yes. Arifpay is a leading Ethiopian fintech providing payment gateway, POS, QR, remittance, and merchant tools used by businesses nationwide.",
  },
  {
    question: "How do I get the best API integration in Ethiopia with Arifpay?",
    answer:
      "Use the Arifpay Developer Hub and payment APIs to accept Telebirr, bank transfers, cards, and wallets. Documentation and SDKs are free for developers.",
  },
  {
    question: "Why You Need our Payment Solution",
    answer:
      "Arifpay simplifies how you accept payments whether through POS, online checkout, or mobile wallets making it faster, more secure, and accessible for both businesses and customers.",
  },
  {
    question: "The Benefits of Using Arifpay Payment options",
    answer:
      "Flexible payment tools, scalable APIs, and transparent pricing help grow your business faster.",
  },
  {
    question: "How to Get Started with Arifpay",
    answer:
      "Simply sign up on our website or contact our team. Submit your business documents and we will help you integrate and start accepting payments quickly.",
  },
  {
    question: "How to Get Your Business Ready for Optimization",
    answer:
      "Optimize your checkout, configure reports, and access insights from your dashboard.",
  },
  {
    question: "How can I become an Arifpay merchant or partner?",
    answer:
      "Simply fill out the merchant onboarding form on our website or contact our sales team. We'll help set up your account and get you started.",
  },
  {
    question: "What kind of support and training does Arifpay provide for its AI solutions?",
    answer:
      "We provide onboarding guides, documentation, live support, and training sessions to help you and your team get the most out of Arifpay's tools and features.",
  },
];

const faqJsonLd = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: homeFaqs.map((faq) => ({
    "@type": "Question",
    name: faq.question,
    acceptedAnswer: {
      "@type": "Answer",
      text: faq.answer,
    },
  })),
};

const websiteJsonLd = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: SITE_NAME,
  url: SITE_URL,
  publisher: {
    "@type": "Organization",
    name: "Arifpay Financial Technologies Share Company",
  },
};

function page({
  title,
  description,
  keywords = DEFAULT_KEYWORDS,
  jsonLd,
}) {
  return { title, description, keywords, jsonLd };
}

export const pages = {
  "/": page({
    title: "ArifPay | Ethiopian Fintech & Digital Payment Solutions",
    description:
      "ArifPay is a leading Ethiopian fintech platform offering secure digital payment gateways, mobile point-of-sale (mPOS), and financial technology solutions in Ethiopia. Ethiopia's Premier Digital Financial Ecosystem — connecting payments, POS & remittance in Ethiopia.",
    keywords: `${DEFAULT_KEYWORDS}, The Best Financial Ecosystem in Ethiopia, Ethiopia's Premier Digital Financial Ecosystem, Ultimate Financial & Payment Ecosystem in Ethiopia, Connecting Payments POS & Remittance in Ethiopia, Arifpay Hub`,
    jsonLd: [organizationJsonLd, websiteJsonLd, faqJsonLd],
  }),
  "/developers": page({
    title: "Best API Integration in Ethiopia | Arifpay Developers",
    description:
      "Build with the best API integration in Ethiopia. Arifpay APIs and SDKs let developers accept Telebirr, cards, wallets, and bank payments quickly and securely.",
    keywords: `${DEFAULT_KEYWORDS}, Arifpay API, developer hub, payment SDK Ethiopia`,
  }),
  "/aboutus": page({
    title: "About Arifpay | Fintech Company in Ethiopia",
    description:
      "Learn about Arifpay Financial Technologies, a leading fintech in Ethiopia trusted by banks, retailers, and merchants for simple, reliable payment solutions.",
  }),
  "/pricing": page({
    title: "Arifpay Pricing | Domestic & International Payments",
    description:
      "See Arifpay pricing for domestic and international payments in Ethiopia. Accept Visa, Mastercard, Telebirr, and bank transfers with simple, transparent fees.",
  }),
  "/gateway": page({
    title: "Best Online Payment Gateway in Ethiopia | Arifpay",
    description:
      "Arifpay is a leading online payment service provider in Ethiopia. Accept Telebirr, cards, wallets, and bank transfers through a secure, scalable payment gateway.",
    keywords: `${DEFAULT_KEYWORDS}, best payment gateway Ethiopia, online payment gateway Ethiopia, online payment provider Ethiopia`,
  }),
  "/gatewayintegration": page({
    title: "Payment API Integration Guide | Arifpay Ethiopia",
    description:
      "Integrate Arifpay's payment gateway API in Ethiopia. Developer docs, collections, and tools for the best API integration for Ethiopian businesses.",
    keywords: `${DEFAULT_KEYWORDS}, API integration guide, payment gateway docs`,
  }),
  "/remittance": page({
    title: "Arif Remit | Cross-Border Money Transfer in Ethiopia",
    description:
      "Arif Remit is a fast, secure cross-border money transfer service in Ethiopia. Send money home from the diaspora to banks, mobile wallets, and cash pickup locations nationwide. Fast & secure money transfers to Ethiopia — send money to Ethiopia instantly with reliable international remittance services.",
    keywords: `${DEFAULT_KEYWORDS}, Arif Remit, Fast & Secure Money Transfers to Ethiopia, Send Money to Ethiopia Instantly, Arif Remit by Arifpay, Reliable International Remittance Services, cross-border money transfer Ethiopia, remittance Ethiopia, send money to Ethiopia`,
  }),
  "/smartpos": page({
    title: "Arif POS | Wallets, Banks & Terminal Management in Ethiopia",
    description:
      "Arif POS is Arifpay's smart POS machine in Ethiopia. Accept payments from multiple wallets and banks, and manage every device with a built-in terminal management system. Smart point of sale systems in Ethiopia — best POS machine for Ethiopian businesses and secure payment terminals for retailers.",
    keywords: `${DEFAULT_KEYWORDS}, Arif POS, Smart Point of Sale Systems in Ethiopia, Best POS Machine for Ethiopian Businesses, Secure Payment Terminals for Retailers, POS machine Ethiopia, POS terminal Ethiopia, terminal management system, wallet POS Ethiopia`,
  }),
  "/mobilepos": page({
    title: "Arif M-POS | Mobile POS in Ethiopia",
    description:
      "Take payments anywhere in Ethiopia with Arif M-POS. A portable, low-cost mobile point of sale for growing businesses.",
  }),
  "/msmes": page({
    title: "Payments for MSMEs in Ethiopia | Arifpay",
    description:
      "Payment tools for micro, small, and medium enterprises in Ethiopia. Accept online, QR, and in-person payments with Arifpay.",
  }),
  "/retail": page({
    title: "Retail Payment Solutions in Ethiopia | Arifpay",
    description:
      "Power retail checkout in Ethiopia with Arifpay POS, QR, and online payments. Faster, more reliable payments for stores and chains.",
  }),
  "/qrpayment": page({
    title: "ArifQR | QR Code Payments in Ethiopia",
    description:
      "Accept cashless QR payments in Ethiopia with ArifQR. Fast, secure scan-to-pay for shops, restaurants, and enterprises. Fast & contactless mobile payments in Ethiopia — scan to pay instantly with secure digital payment solutions for merchants.",
    keywords: `${DEFAULT_KEYWORDS}, Arif QR, Fast & Contactless Mobile Payments in Ethiopia, Scan to Pay Instantly with Arif QR Code Payments, Secure Digital Payment Solutions for Merchants, QR code payments Ethiopia, contactless payments Ethiopia, scan to pay Ethiopia`,
  }),
  "/arif-e-invoice": page({
    title:
      "Arif Electronic Sales Registration System | MOR E-Invoicing in Ethiopia",
    description:
      "Manage sales, electronic invoices, payments, receipts, and inventory with Arif Electronic Sales Registration System. Register IRNs, cash and credit RRNs, and MOR e-invoices in Ethiopia.",
    keywords: `${DEFAULT_KEYWORDS}, Arif Electronic Sales Registration System, e-invoice Ethiopia, electronic invoicing Ethiopia, MOR e-invoice, Ministry of Revenue invoice, IRN Ethiopia, RRN Ethiopia, withholding receipt Ethiopia, cash register Ethiopia`,
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "SoftwareApplication",
      name: "Arif Electronic Sales Registration System",
      applicationCategory: "BusinessApplication",
      operatingSystem: "Web",
      url: `${SITE_URL}/arif-e-invoice`,
      description:
        "Arif Electronic Sales Registration System manages sales, electronic invoices, payments, receipts, and inventory, and supports Ministry of Revenue e-invoicing in Ethiopia.",
      provider: {
        "@type": "Organization",
        name: "Arifpay Financial Technologies Share Company",
        url: SITE_URL,
      },
      areaServed: {
        "@type": "Country",
        name: "Ethiopia",
      },
    },
  }),
  "/arifequb": page({
    title: "Arif Equb | Digital Equb in Ethiopia",
    description:
      "Arif Equb is the best digital Equb in Ethiopia. Contribute in ETB, track every payout in real time with live ledgers and automated draws, and keep group savings secure in escrow.",
    keywords: `${DEFAULT_KEYWORDS}, Arif Equb, digital Equb Ethiopia, best digital Equb, Equb app Ethiopia, group savings Ethiopia, digital savings Ethiopia`,
  }),
  "/hospitality": page({
    title: "Hospitality Payments in Ethiopia | Arifpay",
    description:
      "Payment solutions for hotels, restaurants, and hospitality businesses in Ethiopia. POS, QR, and online checkout from Arifpay.",
  }),
  "/partners": page({
    title: "Become an Arifpay Partner in Ethiopia",
    description:
      "Join Arifpay's partner network in Ethiopia and share revenue while helping businesses accept digital payments.",
  }),
  "/partner2": page({
    title: "Partner Onboarding | Arifpay Ethiopia",
    description:
      "Start your Arifpay partner application. Help Ethiopian businesses accept digital payments and grow with Arifpay.",
  }),
  "/partner3": page({
    title: "Become an Arifpay Partner | Application",
    description:
      "Apply to become an Arifpay commercial partner in Ethiopia and earn from payment processing.",
  }),
  "/partner4": page({
    title: "Partner Information | Arifpay",
    description:
      "Submit partner details to join Arifpay's commercial channel network in Ethiopia.",
  }),
  "/partner5": page({
    title: "Partner Application Complete | Arifpay",
    description:
      "Complete your Arifpay partner registration and start helping businesses in Ethiopia accept payments.",
  }),
  "/transportation": page({
    title: "Transportation Payments in Ethiopia | Arifpay",
    description:
      "Digital payment solutions for transportation and mobility businesses in Ethiopia, from fare collection to merchant checkout.",
  }),
  "/merchantapp": page({
    title: "Arif Merchant App | Sales, Event Management & Payments in Ethiopia",
    description:
      "The Arif Merchant App helps Ethiopian businesses manage sales, transactions, customers, and event management on the go. Create events, collect ticket or event payments, accept QR payments, and run your store from your phone.",
    keywords: `${DEFAULT_KEYWORDS}, Arif Merchant App, merchant app Ethiopia, event management Ethiopia, event payments system Ethiopia, business payments Ethiopia, QR payment app Ethiopia, Qr Payment System Ethiopia, Easy way to pay using payment Link`,
  }),
  "/merchant1": page({
    title: "Become an Arifpay Merchant in Ethiopia",
    description:
      "Grow your Ethiopian business with Arifpay. Accept online, in-store, and mobile payments from one platform.",
  }),
  "/merchant2": page({
    title: "Merchant Onboarding | Arifpay Ethiopia",
    description:
      "Start your Arifpay merchant application and begin accepting digital payments in Ethiopia.",
  }),
  "/merchant3": page({
    title: "Merchant Information | Arifpay",
    description:
      "Provide your business details to complete Arifpay merchant onboarding in Ethiopia.",
  }),
  "/merchant4": page({
    title: "Merchant Application Complete | Arifpay",
    description:
      "Finish your Arifpay merchant registration and start accepting payments across Ethiopia.",
  }),
  "/pressrelease": page({
    title: "Arifpay Press Releases | Fintech News in Ethiopia",
    description:
      "Official Arifpay news and press releases. Updates from one of Ethiopia's leading fintech companies.",
  }),
  "/contactus": page({
    title: "Contact Arifpay | Fintech Support in Ethiopia",
    description:
      "Contact Arifpay Financial Technologies in Addis Ababa. Call 9395 or email info@arifpay.net for payments, APIs, and partnerships.",
  }),
  "/events": page({
    title: "Arifpay Events | Fintech Community in Ethiopia",
    description:
      "Discover Arifpay events, developer meetups, and fintech community programs across Ethiopia.",
  }),
  "/eventdetal1": page({
    title: "Arifpay Event Details",
    description:
      "See upcoming Arifpay event details, agendas, and registration for Ethiopia's fintech community.",
  }),
  "/jobs": page({
    title: "Careers at Arifpay | Fintech Jobs in Ethiopia",
    description:
      "Join Arifpay, a leading fintech in Ethiopia. Browse open roles in engineering, product, and operations.",
  }),
  "/corporate": page({
    title: "Corporate Payments in Ethiopia | Arifpay",
    description:
      "Corporate payment and disbursement solutions from Arifpay, built for Ethiopian enterprises and institutions.",
  }),
  "/corporate1": page({
    title: "Corporate Careers | Arifpay Ethiopia",
    description:
      "Explore corporate career opportunities at Arifpay Financial Technologies in Ethiopia.",
  }),
  "/pagination": page({
    title: "Arifpay Resources",
    description:
      "Browse Arifpay resources, articles, and updates for businesses and developers in Ethiopia.",
  }),
  "/carparking": page({
    title: "Arif Insurance | Insurance Platform in Ethiopia",
    description:
      "Arif Insurance is a secure, data-driven insurance platform for individuals and merchants in Ethiopia.",
  }),
  "/companyprofileviewer": page({
    title: "Arifpay Company Profile | Fintech in Ethiopia",
    description:
      "Read the Arifpay company profile. Learn how a leading Ethiopian fintech delivers payments and API integration.",
  }),
  "/wallet": page({
    title: "Arif Wallet | Digital Wallet in Ethiopia",
    description:
      "Arif Wallet helps businesses and customers send, receive, and manage money digitally across Ethiopia.",
  }),
  "/ecommerce": page({
    title: "Arifshop | Ecommerce Platform to Build Online Stores in Ethiopia",
    description:
      "Arifshop is Arifpay's ecommerce platform in Ethiopia. Launch a branded online store, accept Telebirr, cards, and wallets, and manage products, orders, and delivery in one place.",
    keywords: `${DEFAULT_KEYWORDS}, Arifshop, ecommerce Ethiopia, online store Ethiopia, marketplace Ethiopia, ecommerce platform Ethiopia`,
  }),
  "/healthcare": page({
    title: "Healthcare Payments in Ethiopia | Arifpay",
    description:
      "Payment and working-capital solutions for healthcare providers in Ethiopia, powered by Arifpay.",
  }),
  "/founders-friday": page({
    title: "Founders Friday | Arifpay Ethiopia",
    description:
      "Founders Friday by Arifpay brings Ethiopia's founders, developers, and fintech community together.",
    keywords: `${DEFAULT_KEYWORDS}, Best Developer Ecosystem in Ethiopia, Founders Friday, founders Ethiopia, fintech community Ethiopia`,
  }),
  "/founders-friday-event": page({
    title: "Founders Friday Event | Arifpay",
    description:
      "Register for Arifpay Founders Friday. A community event for founders and builders in Ethiopia.",
  }),
  "/compliance": page({
    title: "Compliance | Arifpay Ethiopia",
    description:
      "Arifpay compliance information and notices for merchants, partners, and stakeholders in Ethiopia.",
  }),
};

export const jobPageSeo = page({
  title: "Job Opening | Arifpay Careers in Ethiopia",
  description:
    "Explore this role at Arifpay, a leading fintech in Ethiopia. Join the team building payment APIs and digital finance.",
});

export function getPageSeo(pathname) {
  let normalized = pathname || "/";
  while (normalized.length > 1 && normalized.endsWith("/")) {
    normalized = normalized.slice(0, -1);
  }
  const key = normalized.toLowerCase();

  if (key.startsWith("/job/")) {
    return jobPageSeo;
  }

  return pages[key] || pages["/"];
}
